<div
  class="flex h-full cursor-pointer items-center px-4 hover:bg-pl-gray-700"
  #buttonToLinkPopover
  (click)="openMenu()"
>
  <div class="hidden items-center gap-2 font-bold text-white sm:flex">
    <p class="text-inherit">{{ participantFullName() }}</p>
    <pl-icon
      [name]="PlIcon.chevron_forward"
      class="block h-6 w-6 transition-all transform duration-300"
      [ngClass]="showMenu() ? '-rotate-90' : 'rotate-90'"
    />
  </div>
  <div class="h-full py-2 sm:hidden">
    <div class="flex aspect-square h-full items-center justify-center rounded-full bg-pl-gray-500 font-bold text-white">
      <span>{{ participantInitials() }}</span>
    </div>
  </div>
</div>

<pl-popover
  [show]="showMenu()"
  [positionX]="PositionX.end"
  [positionY]="PositionY.below"
  (dismissed)="closeMenu()"
  [bindingElement]="buttonToLinkPopover"
>
  <div @opacity *ngIf="showMenu()" class="w-[200px]">
    <h3 class="pointer-events-none font-normal p-2.5 text-pl-gray-450">{{ 'profile.title' | translate }}</h3>
    <p
      *ngFor="let item of menuItems"
      class="cursor-pointer p-2.5 font-bold text-pl-gray-450 hover:bg-pl-gray-300"
      (click)="onMenuItemClicked(item, $event)"
    >
      {{ item.label }}
    </p>
    <div class="border-t border-pl-gray-300 py-2"></div>
    <p class="cursor-pointer p-2.5 font-bold text-pl-orange-800 hover:bg-pl-gray-300" (click)="logout()">
      {{ 'utils.logout' | translate }}
    </p>
  </div>
</pl-popover>
